import styled from 'styled-components';
import { OBannerTextContentAlignment } from './OBannerText.types';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers } = baseVariables;

export const Wrapper = styled.section`
  /* Additional OBannerText Wrapper styling if needed */
`;

export const BrandWrapper = styled.div<{ alignment: OBannerTextContentAlignment }>`
  /* Additional MBrandElement styling if needed */
  display: flex;
  justify-content: ${({ alignment }) => (alignment === OBannerTextContentAlignment.Center ? 'center' : 'start')};
  padding-block-end: ${spacers?.spacers?.[4] ?? '1.5rem'};
`;

export const TextBlockWrapper = styled.div`
  /* Additional MTextBlockStandard styling if needed */
  padding-block-end: ${spacers?.spacers?.[2] ?? '0.5rem'};
`;

export const ParagraphsContainer = styled.div`
  /* Additional MParagraph Wrapper styling if needed */
  display: flex;
  justify-content: center;
  flex-flow: column nowrap;
  gap: ${spacers?.spacers?.[5] ?? '2rem'};

  @media (min-width: 992px) {
    flex-direction: row;
    gap: ${spacers?.spacers?.[5] ?? '2rem'};
  }
`;

export const ParagraphItem = styled.div`
  /* Additional MParagraph styling if needed */
  display: flex;
  flex-direction: column;
  gap: ${spacers?.spacers?.[3] ?? '1rem'};
  flex-basis: 100%;
`;

export const ButtonWrapper = styled.div<{ alignment: OBannerTextContentAlignment }>`
  /* Additional MButton styling if needed */
  display: flex;
  justify-content: ${({ alignment }) => (alignment === OBannerTextContentAlignment.Center ? 'center' : 'start')};
`;
